export default __webpack_public_path__ + "static/media/ic-other-notification-02.8e9bcb65.svg";